import './_header.scss';
import anime from 'animejs';
import { config, debounce, getScrollbarWidth } from '../../../utilities';

$(() => {
    let isMenuOpen = false;
    const $header = $('#header');
    const $menu = $('#header-menu');
    if (!$header.length && !$menu.length) {
        return;
    }
    const $hamburgerTrigger = $('#hamburger-trigger');
    const menuWrapperSel = '#header-menu .header-menu__wrapper';
    // const menuWrapperSel = '.header-menu .header-menu__wrapper';
    const linksSel = '.header-menu ul > li';
    const $headerMenuMobileFooter = $menu.find('.header-menu__mobile-footer');
    // anime objects
    let closeMenu;
    let openMenu;

    function setFooterMenuGap() {
        $headerMenuMobileFooter.css('bottom', '0px');
        $menu.find('.header-menu__list').css('margin-top', '0px');
        const h = window.innerHeight;
        const menuHeight = $menu.outerHeight();
        if (menuHeight > h) {
            const gap = menuHeight - h;
            $headerMenuMobileFooter.css('bottom', `${gap}px`);
            $menu.find('.header-menu__list').css('margin-top', `-${gap}px`);
        }
    }

    if ($menu.length) {
        setFooterMenuGap();
        window.addEventListener('resize', debounce(setFooterMenuGap, 300));

        // init animation timeline
        openMenu = anime.timeline({
            duration: config.animateTime.slower,
            ...config.animeConfig,
        });
        closeMenu = anime.timeline({
            duration: config.animateTime.slower,
            ...config.animeConfig,
        });
        // closing animation for menu and menu container, play simultaneously
        closeMenu.add({
            targets: $menu.get(0),
            top: [0, '-100vh'],
            begin: () => $hamburgerTrigger.addClass('disabled'),
            complete: () => {
                $menu.hide();
                $hamburgerTrigger.removeClass('disabled');
            },
        });
        closeMenu.add(
            {
                targets: menuWrapperSel,
                translateY: [0, '100%'],
                opacity: [1, 0],
            },
            0
        );
        // opening animation for menu and menu container, play simultaneously
        openMenu.add({
            targets: $menu.get(0),
            top: ['-100vh', 0],
            begin: () => {
                $menu.show();
                $hamburgerTrigger.addClass('disabled');
            },
            complete: () => $hamburgerTrigger.removeClass('disabled'),
        });
        openMenu.add(
            {
                targets: menuWrapperSel,
                translateY: ['100%', 0],
                opacity: [0, 1],
            },
            0
        );
        // links appearing animation
        openMenu.add(
            {
                targets: linksSel,
                opacity: [0, 1],
                delay: anime.stagger(50),
            },
            `-=${config.animateTime.slower * 0.6}`
        );
    }

    $hamburgerTrigger.on('click', () => {
        isMenuOpen = !isMenuOpen;

        if (isMenuOpen) {
            if ($('body').hasClass('open-primary-main-popup')) {
                $('.popup--primary .popup__close').trigger('click');
            }
            $('body').addClass('open-menu');
            $('body').removeClass('close-menu');
            if (openMenu) openMenu.play();
            const scrollbarW = getScrollbarWidth();
            $('body').css('padding-right', `${scrollbarW}px`);
            $header.css('padding-right', `${scrollbarW}px`);
        } else {
            $('body').removeClass('open-menu');
            $('body').addClass('close-menu');
            if (closeMenu) closeMenu.play();
            $('body').css('padding-right', '0px');
            $header.css('padding-right', '0px');
        }
    });

    // header scrolling behavior
    let headerH;

    function scrollToShowMotif() {
        const windowT = $(window).scrollTop();

        if (windowT >= 0 && windowT <= headerH) {
            $header.addClass('show-motif');
        } else {
            $header.removeClass('show-motif');
        }
    }

    function initScrollingBehavior() {
        headerH = $header.outerHeight();
        scrollToShowMotif();
    }

    initScrollingBehavior();
    window.addEventListener('scroll', scrollToShowMotif);
    window.addEventListener('resize', debounce(initScrollingBehavior, 300));

    function scrollingTo(t, h, classname) {
        const windowT = $(window).scrollTop();
        const scroll = windowT - t;

        if (scroll >= 0 && scroll <= h) {
            $header.addClass(classname);
        } else {
            $header.removeClass(classname);
        }
    }

    function initHeaderClass($el, classname) {
        const t = $el.position().top;
        const h = $el.outerHeight();
        scrollingTo(t, h, classname);
        function windowScroll() {
            scrollingTo(t, h, classname);
        }
        window.removeEventListener('scroll', windowScroll);
        window.addEventListener('scroll', windowScroll);
    }

    // header scrolls into transparent area
    function initTransparentClass() {
        const $transparent = $('.transparent-header');
        if (!$transparent.length) {
            return;
        }
        initHeaderClass($transparent, 'transparent');
        window.addEventListener(
            'resize',
            debounce(() => {
                initHeaderClass($transparent, 'transparent');
            }, 300)
        );
    }
    initTransparentClass();
});
